import { type Address, ChainId } from '@morpho-org/blue-sdk'
import { getAddress } from 'viem'

/**
 * Vault addresses that bypass the listed check, organized by chain.
 * Add checksummed addresses under the appropriate chain to allow
 * testers to deposit into non-listed vaults during testing.
 */
const TEST_VAULT_ADDRESSES: Partial<Record<ChainId, Set<Address>>> = {
  [ChainId.BaseMainnet]: new Set([
    '0x04F22296E9846854a7b72Bf9AB6Aa2527DC174b3',
    '0x10158847742E51e7A2B3e08f2b7599895207aD08',
    '0x6ffb4C515E16B778471841c2BCEE32D2614D9d92', // Foulk USDC vault
    '0x2c216E1949D03d7C9CFd3DafED1d5E3c9Ab942aD' // Stuart's vault
  ]),
  [ChainId.TempoMainnet]: new Set(['0x31C1F900C070b72548A161E36f1d171c769fc4Bd'])
}

export function isTestVault(chainId: ChainId | undefined, address: Address): boolean {
  if (!chainId) return false
  return TEST_VAULT_ADDRESSES[chainId]?.has(getAddress(address)) ?? false
}
